import { MapPin, Linkedin, Heart } from "lucide-react";
import { motion } from "framer-motion";
import logoLeaf from "@/assets/logo-leaf.svg";
import SectionGlow from "./SectionGlow";
import { duration, ease } from "@/lib/motion";

const Footer = () => (
  <footer
    className="relative bg-charcoal py-10 md:py-16 overflow-hidden"
    style={{ zIndex: 10 }}
    data-dark-section
  >
    <SectionGlow placement="center" opacity={0.04} />
    <div className="container mx-auto relative z-10 grid gap-8 md:grid-cols-4 md:gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2.5 mb-3">
          <img src={logoLeaf} alt="" className="h-8 w-8 brightness-150" />
          <span className="font-heading text-lg md:text-xl">
            <span className="text-gradient-green">Greenleaf</span>
            <span className="text-cream font-semibold"> Digital</span>
          </span>
        </div>
        <p className="text-sm leading-relaxed max-w-sm text-cream/60 mb-3">
          7-day delivery. 100% satisfaction. Direct line to your designer.
        </p>
        <div className="flex items-center gap-4 mt-4">
          <p className="flex items-center gap-1.5 text-xs text-cream/40">
            <MapPin className="h-3 w-3" /> Raleigh, North Carolina
          </p>
          <a
            href="https://www.linkedin.com/company/greenleafdigital-nc/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 rounded-md border border-cream/10 bg-cream/5 px-4 py-3 text-sm font-medium text-cream/60 hover:text-cream hover:border-cream/20 hover:bg-cream/10 transition-colors duration-200 md:px-3 md:py-1.5 md:text-xs"
            aria-label="Greenleaf Digital on LinkedIn"
          >
            <Linkedin className="h-3.5 w-3.5" />
            LinkedIn
          </a>
        </div>
      </div>

      <div>
        <h3 className="font-semibold text-xs text-cream mb-3 uppercase tracking-[0.15em] md:text-sm md:mb-4">Quick Links</h3>
        <ul className="text-cream/60 md:space-y-2">
          {["About", "Services", "Process", "FAQ", "Contact"].map((l) => (
            <li key={l}>
              <a href={`#${l.toLowerCase()}`} className="block py-2.5 text-base md:py-0 md:text-sm hover:text-cream transition-colors duration-200">{l}</a>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-semibold text-xs text-cream mb-3 uppercase tracking-[0.15em] md:text-sm md:mb-4">Contact</h3>
        <ul className="text-cream/60 md:space-y-2">
          <li><a href="tel:8287472665" className="block py-2.5 text-base md:py-0 md:text-sm hover:text-cream transition-colors duration-200">(828) 747-2665</a></li>
          <li><a href="mailto:nick@greenleafdigital.net" className="block py-2.5 text-base md:py-0 md:text-sm hover:text-cream transition-colors duration-200 break-all">nick@greenleafdigital.net</a></li>
        </ul>
      </div>
    </div>

    <div className="container mx-auto relative z-10 mt-10 pt-6 border-t border-cream/10 text-center">
      <p className="text-xs text-cream/40 mb-2">Raleigh, NC · Built for Home Service Pros</p>
      <p className="text-xs text-cream/40">© {new Date().getFullYear()} Greenleaf Digital. All rights reserved.</p>
      <motion.p
        className="text-xs text-cream/40 font-sans mt-3"
        initial={{ opacity: 0, y: 8 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: duration.smooth, ease: ease.smooth, delay: 0.1 }}
      >
        Made with care in Raleigh by <span className="text-accent-sweep">Nick</span>
        <Heart
          aria-hidden="true"
          strokeWidth={2}
          className="inline-block w-[0.8em] h-[0.8em] ml-1 align-[-0.08em] text-[#f87171] fill-[#f87171] animate-heart-pulse"
        />
      </motion.p>
    </div>
  </footer>
);

export default Footer;
